<template>
  <div class="detail">
    <div class="auto_1280">
      <div class="title-box" v-if="current.title">
        <div class="title">{{current.title}}</div>
        <!-- <div class="date">{{current.createTime | format}}</div> -->
      </div>
      <div class="video-box" v-if="current.isUpload === 1">
        <video controls controlsList="nodownload" autoplay muted :src="current.video" id="video"></video>
      </div>
      <div class="content-box" v-html="current.content"></div>
      <div class="nav-box">
        <div class="nav" v-if="detailList[0] !== undefined && detailList[detailList.length - 1] !== undefined">
          <template v-if="lan === 0">
            <div class="prev" v-if="prev" @click="otherId = prev; goOther(detailList[0]);">上一篇：{{detailList[0].title}}</div>
            <div class="next" v-if="next" @click="otherId = next; goOther(detailList[detailList.length - 1]);">下一篇：{{detailList[detailList.length - 1].title}}</div>
          </template>
          <template v-if="lan === 1">
            <div class="prev" v-if="prev" @click="otherId = prev; goOther(detailList[0]);">Prev：{{detailList[0].title}}</div>
            <div class="next" v-if="next" @click="otherId = next; goOther(detailList[detailList.length - 1]);">Next：{{detailList[detailList.length - 1].title}}</div>
          </template>
        </div>
        <div class="back" @click="goBack" v-if="lan === 0">返回列表</div>
        <div class="back" @click="goBack" v-else-if="lan === 1">Back</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VloveDonation',
  filters: {
    format (value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const sdate = ('0' + date.getDate()).slice(-2)
      const result = year + '.' + month + '.' + sdate
      return result
    }
  },
  data () {
    return {
      detailList: [],
      current: {},
      articleTypeId: this.$route.query.articleTypeId,
      id: this.$route.query.id,
      path: this.$route.path,
      prev: false,
      next: false,
      lan: this.$store.state.isEn,
      area: this.$store.state.area
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    },
    '$store.state.area' () {
      this.area = this.$store.state.area
    }
  },
  mounted () {
    const self = this
    self.init()
  },
  methods: {
    init () {
      this.detailList = []
      this.current = {}
      const detail = []
      let params = {}
      // articleTypeId === 1 为视频详情，articleTypeId === 8 为唯爱心详情
      if (parseInt(this.articleTypeId) === 1) {
        params = { id: parseInt(this.id), articleTypeId: parseInt(this.articleTypeId), isDelete: 0, state: 1, bLanguage: this.lan, video: 'true' }
      } else {
        params = { id: parseInt(this.id), articleTypeId: parseInt(this.articleTypeId), isDelete: 0, state: 1, bLanguage: this.lan }
      }
      this.$api.post('api/benefitArticle/queryNewsPage', params, r => {
        if(r.msg == '数据不存在') {
          this.$router.push({
            name: 'Home',
            query: {
              columnId: 38
            }
          })
          return
        }
        r.data.forEach((item) => {
          detail.push(item)
          this.detailList = detail
          if (item.id === parseInt(this.id)) {
            this.current = item
            this.current.content = this.current.content.replace(/%/g, '%25')
            this.current.content = decodeURIComponent(this.current.content)
          }
          if (item.articleTypeParentId === 4) {
            this.$store.commit('changeArea', item.articleTypeId)
          }
        })
        // 判断是否存在上一条
        if (detail[0].id === parseInt(this.id)) {
          this.prev = false
        } else {
          this.prev = true
        }
        // 判断是否存在下一条
        if (detail[detail.length - 1].id === parseInt(this.id)) {
          this.next = false
        } else {
          this.next = true
        }

        if (localStorage.getItem('path') === null) {
          let menuList
          try {
            menuList = JSON.parse(localStorage.getItem('routeList'))
            menuList.forEach((item) => {
              if (item.id === this.current.articleTypeParentId) {
                item.children.forEach((inner) => {
                  if (inner.id === this.current.articleTypeId) {
                    localStorage.setItem('path', inner.requestTo.toLowerCase())
                  }
                })
              } else if (this.current.articleTypeId === 1) {
                localStorage.setItem('path', 'vlovemother')
              }
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    goOther (item) {
      this.$router.push({
        path: this.$route.path,
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: this.articleTypeId,
          id: item.id
        }
      })
      this.id = item.id
      this.init()
    },
    goBack () {
      const index = this.path.lastIndexOf('/')
      this.path = this.path.substring(0, index + 1) + localStorage.getItem('path')
      this.$router.push({
        path: this.path,
        query: {
          columnId: this.$route.query.columnId
        }
      })
    }
  }
}
</script>
<style>
.detail{padding-bottom: 6%;}
.detail .title-box{padding: 1% 0 3%; border-bottom: 1px solid #eee;}
.no-menu .detail .title-box{padding: 4% 0 2% 0;}
.detail .title{font-size: 36px; color: #333; text-align: center; padding-bottom: 1%;}
.detail .date{font-weight: lighter; color: #999; text-align: center;}
.detail .video-box{padding: 3% 0; text-align: center;}
.detail video{width: 70%;}
.detail .content-box{padding-bottom: 6%; border-bottom: 2px solid rgba(228,0,127,0.1);}
.detail .txt,
.detail span,
.detail p{line-height: 2!important; padding-top: 1%;}
.detail p{margin: 0;}
.detail .pic{padding-top: 4%;}
/* .detail img{width: 100%!important; height: auto!important;} */
.detail .tit{padding-top: 4%; font-size: 24px;}
.detail .nav-box{margin-top: .1%; padding-top: 2%; border-top: 1px solid rgba(228,0,127,0.1); position: relative; padding-right: 180px;}
.detail .prev,.detail .next{color: #333; line-height: 2; cursor: pointer;}
.detail .prev:hover,.detail .next:hover{color: #e4007f; transition: all .3s;}
.detail .back{position: absolute; right: 0; top: 35%; width: 140px; line-height: 50px; height: 50px; text-align: center; color: #fff; background: url(../assets/a_prev_on.png)no-repeat 20% center #e4007f; border-radius: 20px 0; cursor: pointer; padding-left: 15px;}
@media(max-width: 640px){
  .detail .title{font-size: 22px; color: #333; text-align: center; padding-bottom: 2%;}
  .detail .tit{font-size: 18px;}
  .detail .txt,
  .detail p{font-size: 14px; line-height: 1.8;}
  .detail .nav-box{padding-right: 0;}
  .detail .back{position: initial; margin-top: 2%;}
  .detail img{width: 100%!important; height: auto!important;}
  .detail .txt,
  .detail span,
  .detail p{font-size: 14px!important; line-height: 1.8!important;}

  .detail .back{line-height: 45px; height: 45px; width: 120px; font-size: 14px;}
}
</style>
